import React from "react";
import { Card, Input } from "@nextui-org/react";
import { TbList, TbSearch } from "react-icons/tb";

const AltLedgerFilterCard = ({ row, onRowChange, search, onSearchChange }) => {
  return (
    <Card.Header
      css={{
        display: "inline-flex",
        justifyContent: "space-between",
        gap: "10px",
      }}
    >
      <Input
        aria-label="Set Row"
        contentLeft={<TbList />}
        type="number"
        bordered
        css={{ w: "100px" }}
        size="sm"
        value={row}
        onChange={(event) => onRowChange(event.target.value)}
      />
      <Input
        aria-label="Search"
        contentLeft={<TbSearch />}
        type="text"
        placeholder="Search phone, customer, issue, note..."
        bordered
        size="sm"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        clearable
      />
    </Card.Header>
  );
};

export default AltLedgerFilterCard;
